import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { ShowSection, ShowPageLayout } from 'framework/ui/layout';
import { ControlledShow } from 'framework/show';
import { staffingDataGetters } from 'domain/staffing/dashboard/dashboard/utils/staffingDataGetters';
import StaffingDashboardModalsProvider from 'domain/staffing/dashboard/dashboard/components/StaffingDashboardModalsProvider';
import { StaffingProjectBreadcrumbs, StaffingProjectOverview, StaffingProjectTabsMenu } from './shared';
import { useStaffingProjectContext } from './context/StaffingProjectContext';
import { DashboardProvider } from 'framework/ui/dashboard';
import { ACCESS_INFO_ACTIONS, ACCESS_INFO_SECTIONS, useProjectSecurityContext } from 'domain/shared/newProject';
import { SwitchToProjectViewButton } from 'domain/shared/project';

const StaffingProjectOverviewSection = () => {
  const { staffingData, project, refetch } = useStaffingProjectContext();
  const { isAccessGranted } = useProjectSecurityContext();

  if (!staffingData) return null;

  return (
    <ControlledShow data={staffingData}>
      <ShowSection
        justifyContent="space-between"
        titleId="staffing-project-title"
        title={project?.name || 'Project'}
        titleVariant="h2"
        actions={[
          isAccessGranted(ACCESS_INFO_SECTIONS.PROJECT_VIEW_NAVIGATION, ACCESS_INFO_ACTIONS.SWITCH_TO_PROJECT_VIEW) && (
            <SwitchToProjectViewButton isStaffingView={false} projectId={project.id} />
          ),
        ]}
      >
        <StaffingDashboardModalsProvider refetch={refetch}>
          <StaffingProjectOverview />
        </StaffingDashboardModalsProvider>
      </ShowSection>
    </ControlledShow>
  );
};

const StaffingProjectLayout = () => {
  return (
    <DashboardProvider
      dataGetters={{
        ...staffingDataGetters,
        people: item => [...staffingDataGetters.people(item)],
      }}
    >
      <ShowPageLayout breadcrumbs={<StaffingProjectBreadcrumbs />} hasSeparateSections>
        <ShowSection>
          <StaffingProjectOverviewSection />
          <Box mt={2}>
            <StaffingProjectTabsMenu />
          </Box>
        </ShowSection>

        <Box mt={2}>
          <Outlet />
        </Box>
      </ShowPageLayout>
    </DashboardProvider>
  );
};

export default StaffingProjectLayout;
